import React from 'react';
import styles from './skeleton-loader.module.css';

export function SkeletonLoader({ height = '50px', width = '100%', borderRadius = '20px', backgroundColor = 'var(--borders_2)' }: { height?: string; width?: string; borderRadius?: string; backgroundColor?: string }): JSX.Element {
  function validateSize(size: string) {
    return /^[0-9]*$/.test(size) ? `${size}px` : size;
  }

  return (
    <div style={{ height: validateSize(height), width: validateSize(width) }}>
      <div className={styles.loader} style={{ borderRadius, backgroundColor }} />
    </div>
  );
}
